import create from "zustand";
import { persist } from "zustand/middleware";
import { STATE_CONSTANTS_ADDRESS } from "./useConstantState";

export const StoreSearch = create(
  (set, get) => ({
    search: "",
    setSearch: (search) => set(() => ({ search })),
  }),
  {
    name: "search",
  }
);

export const StoreTabAddress = create(
  (set, get) => ({
    tab: STATE_CONSTANTS_ADDRESS.SEARCH,
    setTab: (tab) => set(() => ({ tab })),
  }),
  {
    name: "tab",
  }
);

export const StoreTabSize = create(
  (set, get) => ({
    tabSize: "S",
    setTabSize: (tabSize) => set(() => ({ tabSize })),
  }),
  {
    name: "tabSize",
  }
);

export const StoreSelectedLocation = create(
  (set, get) => ({
    selectedLocation: false,
    setSelectedLocation: (selectedLocation) =>
      set(() => ({ selectedLocation })),
  }),
  {
    name: "selectedLocation",
  }
);

export const SystemStoreBasketAddress = create(
  persist(
    (set, get) => ({
      address: false,
      setAddress: (address) => set(() => ({ address })),
    }),
    {
      name: "address",
      getStorage: () => sessionStorage,
    }
  )
);

export const StoreIsShowAnotherValue = create(
  (set, get) => ({
    isShowAnother: false, // this is value use for show description address when user not login
    setIsShowAnother: (isShowAnother) => set(() => ({ isShowAnother })),
  }),
  {
    name: "isShowAnother",
  }
);

export const SystemStoreOrders = create(
  (set, get) => ({
    orders: "loading",
    setOrders: (orders) => set(() => ({ orders })),
  }),
  {
    name: "orders",
  }
);

export const SystemStoreStar = create(
  (set, get) => ({
    star: false,
    setStar: (star) => set(() => ({ star })),
  }),
  {
    name: "star",
  }
);

export const StoreSameDayService = create(
  persist(
    (set, get) => ({
      sameDayService: false,
      setSameDayService: (sameDayService) => set(() => ({ sameDayService })),
    }),
    {
      name: "sameDayService",
      getStorage: () => sessionStorage,
    }
  )
);

export const StoreDetailAddress = create(
  persist(
    (set, get) => ({
      detailAddress: "",
      setDetailAddress: (detailAddress) => set(() => ({ detailAddress })),
    }),
    {
      name: "detailAddress",
      getStorage: () => sessionStorage,
    }
  )
);

export const StoreLoadingOrder = create(
  (set, get) => ({
    loadingOrder: false,
    setLoadingOrder: (loadingOrder) => set(() => ({ loadingOrder })),
  }),
  {
    name: "loadingOrder",
  }
);
